import React from 'react';
import resume from '../assets/ResumeMLopez.pdf';

export default function Projects() {
  return (
    <div className="resume d-flex flex-justify-center">
      <iframe title="Maya Lopez resume" src={resume}></iframe>
    </div>
  )
}